import { DELIMITER, delimiterSymbol } from "Common/dictionaries/delimiter";
import { DOCUMENT_TYPE } from "Common/dictionaries/documentType";
import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
import { NAMESPACE as PARENT_NAMESPACE } from "../constants";
export const NEW_DOCUMENT = {
    Id: 0,
    Name: "",
    Created: 0,
    Updated: 0,
    ProjectId: 0,
    Type: DOCUMENT_TYPE.GRAPH,
    Description: ""
};
export const requiredFields = ["Name", "ProjectId"];
export const NAMESPACE = "documentEditor";
export const FULL_NAMESPACE = createNamespace(PARENT_NAMESPACE, NAMESPACE);
export { PARENT_NAMESPACE as PAGE_NAMESPACE };
export const MAX_FILE_SIZE = 5242880;
export const ALLOWED_EXTENSIONS = ["csv"];
export const MAX_ROWS_PREVIEW_IMPORT = 50;
export const IMPORT_PARAMS_DEFAULT = {
    startLine: 1,
    containsColumnNames: true,
    delimiter: delimiterSymbol[DELIMITER.COMMA],
    delimiterId: DELIMITER.COMMA,
    canUseContainsColumnNames: true
};
